/**
 * Composable for fetching and managing supervised users (employees)
 * Extracts the logic for getting users where the current user is set as supervisor
 */
export const useSupervisedUsers = () => {
  const userStore = useUserStore()
  const supervisedUsers = ref<User[]>([])
  const supervisedUserIds = ref<number[]>([])
  const isLoading = ref(false)

  /**
   * Fetches all active users supervised by the current user
   * @returns Array of supervised user IDs
   */
  const fetchSupervisedUsers = async (): Promise<number[]> => {
    if (!userStore.user?.id) {
      supervisedUsers.value = []
      supervisedUserIds.value = []
      return []
    }

    isLoading.value = true
    try {
      const response = await useApi(
        `users?filter[supervisor]=${userStore.user.id}&filter[inactive]=false&per_page=1000`,
        'GET'
      )
      supervisedUsers.value = response.data || []
      supervisedUserIds.value = supervisedUsers.value.map((u: User) => u.id)
      return supervisedUserIds.value
    } catch (error) {
      console.error('[useSupervisedUsers] ❌ Error fetching supervised users:', error)
      supervisedUsers.value = []
      supervisedUserIds.value = []
      return []
    } finally {
      isLoading.value = false
    }
  }

  return {
    supervisedUsers,
    supervisedUserIds,
    fetchSupervisedUsers,
    isLoading
  }
}
